import { ITCQualificationResponse } from 'types';

import { api } from './api';

interface ItcCalculationRequest {
  inverters?: Array<{
    manufacturer?: string | null;
    model?: string | null;
    count?: number | null;
    vintage?: string | null;
  }>;
  panelManufacturer?: string;
  panelModel?: string;
  mountingHardware?: Array<{
    type: string;
    mountingHardwareModels: Array<{
      manufacturer: string;
      category: string;
      sku: string;
    }>;
  }>;
  storage?: Array<{
    manufacturer?: string | null;
    model?: string | null;
    count?: number | null;
    vintage?: string | null;
  }>;
  enphaseInverterAttested?: boolean;
  enphaseStorageAttested?: boolean;
}

export const itcApi = api.injectEndpoints({
  endpoints: (build) => ({
    calculateItc: build.mutation<ITCQualificationResponse, ItcCalculationRequest>({
      query: (systemDesign) => ({
        url: 'admin/itc/calculate',
        method: 'POST',
        body: systemDesign,
      }),
    }),
    calculateAccountItc: build.mutation<
      ITCQualificationResponse,
      { id: string; systemDesign: ItcCalculationRequest }
    >({
      query: ({ id, systemDesign }) => ({
        url: `accounts/${id}/itc/calculate`,
        method: 'POST',
        body: systemDesign,
      }),
    }),
  }),
});

export const { useCalculateItcMutation, useCalculateAccountItcMutation } = itcApi;
